import get from 'lodash/get';
import { createAction } from 'redux-act';
import { selectCurrentId } from '@gandi/redux-sharing';
import { GET, POST, PATCH } from 'gandi.redux-fetcher';
import { addDiscount, addProduct, addProducts, removeDiscount, removeProduct, removeProducts, updateProduct, updateProducts, addBundle, removeBundle, addBulkDiscount } from '../modules/actions';
import { selectCartUUID, selectCartProductOwner } from '../modules/selectors';
const assignPayload = (...args) => args;
const assignMeta = action => () => ({
  cart: true,
  action
});
export const retrieveDefaultTemplate = kind => (dispatch, getState) => {
  const sharingId = selectCartProductOwner(getState()) || selectCurrentId(getState());
  const url = `/templates/templates/defaults/${kind}`;
  return dispatch(GET(url, {
    params: {
      sharing_id: sharingId
    },
    on200: response => response,
    not200: response => Promise.reject(response)
  })).then(response => ({
    templateId: response.data.id,
    templateName: response.data.name,
    templateDescription: response.data.description
  }));
};
export const applyTemplate = ({
  process,
  productType,
  templateId,
  templateName,
  templateDescription,
  noConflict,
  configId,
  locked
}) => (dispatch, getState) => {
  const cartId = selectCartUUID(getState());
  const body = {
    process,
    product_type: productType,
    payload: {
      template_id: templateId
    }
  };
  if (templateName !== undefined) {
    body.payload.template_name = templateName || undefined;
  }
  if (templateDescription !== undefined) {
    body.payload.template_description = templateDescription || undefined;
  }
  if (locked) {
    body.payload.locked = locked;
  }
  const httpVerb = configId ? PATCH : POST;
  const url = configId ? `/cart/carts/${cartId}/configurations/${configId}` : `/cart/carts/${cartId}/configurations`;
  return dispatch(httpVerb(url, body, {
    on20X: response => response,
    not20X: response => {
      if (response.status === 409) {
        if (noConflict && !configId) {
          return dispatch(applyTemplate({
            process,
            productType,
            templateId,
            templateName,
            templateDescription,
            configId: get(response.data.errors, '[0].location', '').split('=')[1],
            locked
          }));
        }
        return response;
      }
      return Promise.reject(response);
    },
    headers: {
      'Content-Type': httpVerb === PATCH ? 'application/merge-patch+json' : 'application/json'
    }
  }));
};
export const addCartProduct = createAction('Add cart product', assignPayload, assignMeta(addProduct));
export const addCartProducts = createAction('Add cart products', assignPayload, assignMeta(addProducts));
export const updateCartProduct = createAction('Update cart product', assignPayload, assignMeta(updateProduct));
export const updateCartProducts = createAction('Update cart products', assignPayload, assignMeta(updateProducts));
export const upsertCartProduct = createAction('Add or update cart product', ({
  productData,
  productId,
  extra,
  options
}) => productId ? [{
  productId,
  payload: productData.payload,
  options
}] : [{
  productData,
  extra,
  options
}], ({
  productId
}) => ({
  cart: true,
  action: productId ? updateProduct : addProduct
}));
export const removeCartProduct = createAction('Remove cart product', assignPayload, assignMeta(removeProduct));
export const removeCartProducts = createAction('Remove cart products', assignPayload, assignMeta(removeProducts));
export const addCartDiscount = createAction('Add cart discount', assignPayload, assignMeta(addDiscount));
export const removeCartDiscount = createAction('Remove cart discount', assignPayload, assignMeta(removeDiscount));
export const addCartBundle = createAction('Add cart bundle', assignPayload, assignMeta(addBundle));
export const removeCartBundle = createAction('Remove cart bundle', assignPayload, assignMeta(removeBundle));
export const addCartBulkDiscount = createAction('Add cart bulk discount', assignPayload, assignMeta(addBulkDiscount));